import request from '../../untils/request';

export function selectOffMeterList(data) {
  return request({
    url: '/waterMeter/selectOffMeterList',
    method: 'get',
    params: data,
  });
}
// 欠费历史告警
export function arrearsSelectList(data) {
  return request({
    url: '/arrearsAlarmRecordWater/selectList',
    method: 'get',
    params: data,
  });
}
// 欠费实时告警
export function arrearsLastSelectList(data) {
  return request({
    url: '/arrearsAlarmLastRecordWater/selectList',
    method: 'get',
    params: data,
  });
}
// 数据历史告警
export function selectHistoryData(data) {
  return request({
    url: '/dataAlarmRecordWater/selectHistoryData',
    method: 'get',
    params: data,
  });
}
// 数据实时告警
export function selectRealData(data) {
  return request({
    url: '/dataAlarmLastRecordWater/selectRealData',
    method: 'get',
    params: data,
  });
}

// 获取商户名称下拉列表
export function selectListLesseeName(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}